module.exports = __webpack_public_path__ + "static/media/cert_122.026a9358.jpg";